import {
  openConfigModal,
  setStoredComponentChoice
} from './screen-config-modal'

import {
  Q7_SEVEN_SEATER_GROUP_ID,
  getQ7SeatModalTitle,
  getQ7SeatOptions,
  getQ7SeatLabelByValue,
  isQ9G8Model
} from './screen-car-select-q7-seat-options'

import { doAjax } from './helper'

console.log('[Q7 sevenSeater] file loaded')

function isQ7CarSelectScreen() {
  const screen = document.querySelector('#car-select-screen')
  return !!screen && (screen.classList.contains('q7_g8') || screen.classList.contains('q9_g8'))
}

function isQ9G8CarSelectScreen() {
  return !!document.querySelector('#car-select-screen')?.classList.contains('q9_g8')
}

function getSelectedCarModel() {
  return document.querySelector('input[name="car-model"]:checked')?.value || ''
}

function getCarModelFromEvent(event) {
  const label = event.target.closest('label')
  const input =
    label?.querySelector('input[name="car-model"]') ||
    event.target.closest('.aui-radio')?.querySelector('input[name="car-model"]')

  return input?.value || getSelectedCarModel()
}

function usesQ9SeatDefaults(carModel) {
  // Auf dem q9_g8-Screen sind alle Modelle 118/119/120 – auch wenn :checked
  // beim Klick-Event noch nicht aktualisiert ist.
  return isQ9G8CarSelectScreen() || isQ9G8Model(carModel)
}

function syncStoredSevenSeaterFromBackend() {
  doAjax({ get_customizable_options: 1 }, (response) => {
    console.log('[Q7 sevenSeater] AJAX response:', response)
    console.log('[Q7 sevenSeater] raw value:', response?.car_frontseat?.sevenSeater)

    const backendValue =
      response?.car_frontseat?.sevenSeater ??
      response?.car_frontSeat?.sevenSeater ??
      response?.car_frontseat?.seven_seater ??
      response?.sevenSeater ??
      null

    const carModel = getSelectedCarModel()
    let valueToStore = null

    if (backendValue !== null && backendValue !== undefined && backendValue !== '') {
      valueToStore = String(backendValue)
    }

    // Q9 G8: Standard = Code 3; Code 0 entfällt und darf nicht als remembered bleiben
    if (usesQ9SeatDefaults(carModel)) {
      const availableCodes = getQ7SeatOptions(carModel || '118').map((entry) => entry.code)
      if (!valueToStore || !availableCodes.includes(valueToStore)) {
        valueToStore = '3'
      }
    }

    if (valueToStore !== null) {
      setStoredComponentChoice(Q7_SEVEN_SEATER_GROUP_ID, valueToStore)
      console.log('[Q7 sevenSeater] gespeicherter Wert geladen:', {
        value: valueToStore,
        label: getQ7SeatLabelByValue(valueToStore, carModel || '118')
      })
    } else {
      console.log('[Q7 sevenSeater] kein gespeicherter Wert im Backend gefunden')
    }
  })
}

function openSevenSeaterModal(carModel) {
  console.log('[Q7 sevenSeater] open modal', { carModel })

  const model = carModel || getSelectedCarModel()
  const seatOptions = getQ7SeatOptions(model)

  // Standardkonfiguration beim Öffnen explizit setzen (rememberedCode hat in
  // buildGroups Vorrang vor option.default und würde sonst modellübergreifend hängen bleiben).
  // Q9 G8 (118/119/120) → Code 3 | Q7 G8 (115/116/117) → Code 0
  if (usesQ9SeatDefaults(model)) {
    setStoredComponentChoice(Q7_SEVEN_SEATER_GROUP_ID, '3')
    console.log('[Q7 sevenSeater] Q9-Standard gesetzt: 7 Sitze (Code 3)')
  } else {
    setStoredComponentChoice(Q7_SEVEN_SEATER_GROUP_ID, '0')
    console.log('[Q7 sevenSeater] Q7-Standard gesetzt: 5 Sitze (Code 0)')
  }

  openConfigModal({
    title: getQ7SeatModalTitle(
                'choose_seat_count',
                'Bitte wählen Sie die entsprechende Sitzanzahl aus.'
            ),
    groups: [
      {
        id: Q7_SEVEN_SEATER_GROUP_ID,
        type: 'component',
        options: seatOptions
      }
    ],
    onSubmit: (selections, state) => {
      const selection = selections.find((entry) => entry.id === Q7_SEVEN_SEATER_GROUP_ID)
      const selectedValue = selection?.code ?? ''
      const selectedLabel = getQ7SeatLabelByValue(selectedValue, model)

      setStoredComponentChoice(Q7_SEVEN_SEATER_GROUP_ID, selectedValue)

      console.log('[Q7 sevenSeater] gespeichert:', {
        value: selectedValue,
        label: selectedLabel,
        state,
        windowValue: window.q7SeatConfig
      })
    },
    onCancel: () => {
      console.log('[Q7 sevenSeater] modal abgebrochen')
    }
  })
}

export function initQ7CarSelectSeatModal() {
  console.log('[Q7 sevenSeater] init called')

  if (!isQ7CarSelectScreen()) {
    console.log('[Q7 sevenSeater] nicht auf q7_g8/q9_g8 car-select screen')
    return
  }

  // Screen-Standard sofort setzen (vor erstem Modal-Open), damit kein Wert
  // vom anderen Modellzweig (Q7 ↔ Q9) in sessionStorage hängen bleibt.
  if (isQ9G8CarSelectScreen()) {
    setStoredComponentChoice(Q7_SEVEN_SEATER_GROUP_ID, '3')
  } else {
    setStoredComponentChoice(Q7_SEVEN_SEATER_GROUP_ID, '0')
  }

  syncStoredSevenSeaterFromBackend()

  document.addEventListener('click', (event) => {
    const radio = event.target.closest('.aui-radio')
    if (!radio) return

    if (!isQ7CarSelectScreen()) return

    const carModel = getCarModelFromEvent(event)
    console.log('[Q7 sevenSeater] radio click detected', { radio, carModel })

    openSevenSeaterModal(carModel)
  })
}
